import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import ReferenceMediaTextSection from './reference-media-text-section';

export function ReferenceBulletPoint({ blok }) {
  return <div {...storyblokEditable(blok)} className="hidden" aria-hidden="true" />;
}

export default function ReferenceChallengeSection({ blok }) {
  return <ReferenceMediaTextSection blok={blok} sectionClassName="pt-12 lg:pt-20" titleTag="h3" imageSizes="(max-width: 1024px) 100vw, 40vw" />;
}
